/**
 * Best-effort split of Slovak company seat (sídlo) from registry-style strings,
 * e.g. "Hlavná 4/22, 930 28 Okoč" → street + city.
 */
export function parseSkSidlo(sidlo: string): { street: string; city: string } {
  const s = sidlo.trim();
  if (!s) return { street: "", city: "" };

  const pscCity = /,?\s*(\d{3}\s*\d{2})\s+(.+)$/;
  const m = s.match(pscCity);
  if (m && m.index !== undefined) {
    const street = s.slice(0, m.index).replace(/,\s*$/, "").trim();
    return { street: street || s, city: m[2].trim() };
  }

  const lastComma = s.lastIndexOf(",");
  if (lastComma > 0) {
    const street = s.slice(0, lastComma).trim();
    const tail = s.slice(lastComma + 1).trim();
    return { street, city: tail };
  }

  return { street: s, city: "" };
}
